import { render, staticRenderFns } from "./DocUploadIcon.vue?vue&type=template&id=90c37bbc&"
import script from "./DocUploadIcon.vue?vue&type=script&lang=ts&"
export * from "./DocUploadIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports